import {
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBadgeCheck,
  faBalanceScale,
  faBan,
  faBars,
  faBookOpen,
  faBookOpenReader,
  faBooks,
  faBriefcase,
  faBuilding,
  faBullseye,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarClock,
  faCalendarDays,
  faCalendarMinus,
  faCalendarPlus,
  faCalendarUsers,
  faCalendarXmark,
  faCertificate,
  faChalkboardUser,
  faChampagneGlasses,
  faChartBar,
  faChartNetwork,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleChevronUp,
  faCity,
  faClock,
  faClockRotateLeft,
  faCloudArrowUp,
  faCloudExclamation,
  faCloudPlus,
  faCog,
  faCommentNodes,
  faCompass,
  faCookieBite,
  faCreditCard,
  faDoorOpen,
  faDownload,
  faEarthAmericas,
  faEdit,
  faEllipsisVertical,
  faEnvelopeOpenText,
  faEnvelope,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileCircleXmark,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFileUser,
  faFlag,
  faFolder,
  faGavel,
  faGlobe,
  faGlobePointer,
  faGlobeStand,
  faGraduationCap,
  faHandshake,
  faHashtag,
  faHome,
  faHouse,
  faHouseBuilding,
  faIdBadge,
  faIdCard,
  faImage,
  faImagePolaroidUser,
  faImages,
  faInfoCircle,
  faLandmark,
  faList,
  faLocationDot,
  faLocationPin,
  faLock,
  faMagnifyingGlass,
  faMap,
  faMapLocation,
  faMedal,
  faMicrophone,
  faMoneyBillWave,
  faNewspaper,
  faPaperclip,
  faPaperPlane,
  faPartyHorn,
  faPeopleDress,
  faPeopleGroup,
  faPeopleLine,
  faPeopleRoof,
  faPercent,
  faPhone,
  faPhoneFlip,
  faPodcast,
  faQuestionCircle,
  faQuoteLeft,
  faQuoteRight,
  faReceipt,
  faRedo,
  faRefresh,
  faRss,
  faSchool,
  faSchoolFlag,
  faScroll,
  faSearch,
  faShare,
  faShareNodes,
  faShieldAlt,
  faSignInAlt,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSpinner,
  faSpinnerThird,
  faStar,
  faTachometerAlt,
  faTag,
  faThLarge,
  faTimesCircle,
  faUpDown,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserCog,
  faUserEdit,
  faUserFriends,
  faUserGraduate,
  faUserGroup,
  faUserLock,
  faUserPlus,
  faUsers,
  faUsersGear,
  faUserSlash,
  faUsersViewfinder,
  faUserTie,
  faVideo,
  faXmark
} from '@fortawesome/pro-solid-svg-icons'

import {
  faAddressCard as falAddressCard,
  faBookOpenReader as falBookOpenReader,
  faBooks as falBooks,
  faCalendar as falCalendar,
  faCalendarUsers as falCalendarUsers,
  faChartSimple as falChartSimple,
  faCircleChevronUp as falCircleChevronUp,
  faEnvelope as falEnvelope,
  faGavel as falGavel,
  faGlobe as falGlobe,
  faGlobeStand as falGlobeStand,
  faHandshake as falHandshake,
  faIdCard as falIdCard,
  faList as falList,
  faLocationDot as falLocationDot,
  faNewspaper as falNewspaper,
  faPartyHorn as falPartyHorn,
  faPeopleLine as falPeopleLine,
  faPeopleRoof as falPeopleRoof,
  faPercent as falPercent,
  faPhone as falPhone,
  faPodcast as falPodcast,
  faQuoteRight as falQuoteRight,
  faScaleBalanced as falScaleBalanced,
  faSchoolFlag as falSchoolFlag,
  faSpinnerThird as falSpinnerThird,
  faStar as falStar,
  faUserGraduate as falUserGraduate,
  faUserGroup as falUserGroup,
  faUserPlus as falUserPlus,
  faUsers as falUsers,
  faUsersViewfinder as falUsersViewfinder,
  faXmark as falXmark
} from '@fortawesome/pro-light-svg-icons'

import {
  faAmazon,
  faApple,
  faDeezer,
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faSoundcloud,
  faSpotify,
  faXTwitter,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

export const solidIcons = [
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faArrowUp,
  faBadgeCheck,
  faBalanceScale,
  faBan,
  faBars,
  faBookOpenReader,
  faBookOpen,
  faBooks,
  faBriefcase,
  faBuilding,
  faBullseye,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarClock,
  faCalendarDays,
  faCalendarMinus,
  faCalendarPlus,
  faCalendarUsers,
  faCalendarXmark,
  faCalendar,
  faCertificate,
  faChalkboardUser,
  faChampagneGlasses,
  faChartBar,
  faChartNetwork,
  faChartSimple,
  faCheckCircle,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleChevronUp,
  faCircle,
  faCity,
  faClockRotateLeft,
  faClock,
  faCloudArrowUp,
  faCloudExclamation,
  faCloudPlus,
  faCog,
  faCommentNodes,
  faCompass,
  faCookieBite,
  faCreditCard,
  faDoorOpen,
  faDownload,
  faEarthAmericas,
  faEdit,
  faEllipsisVertical,
  faEnvelopeOpenText,
  faEnvelope,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faEye,
  faFileAlt,
  faFileCertificate,
  faFileCircleXmark,
  faFileContract,
  faFileInvoiceDollar,
  faFileInvoice,
  faFilePdf,
  faFileUser,
  faFile,
  faFlag,
  faFolder,
  faGavel,
  faGlobePointer,
  faGlobeStand,
  faGlobe,
  faGraduationCap,
  faHandshake,
  faHashtag,
  faHome,
  faHouseBuilding,
  faHouse,
  faIdBadge,
  faIdCard,
  faImagePolaroidUser,
  faImage,
  faImages,
  faInfoCircle,
  faLandmark,
  faList,
  faLocationDot,
  faLocationPin,
  faLock,
  faMagnifyingGlass,
  faMapLocation,
  faMap,
  faMedal,
  faMicrophone,
  faMoneyBillWave,
  faNewspaper,
  faPaperPlane,
  faPaperclip,
  faPartyHorn,
  faPeopleDress,
  faPeopleGroup,
  faPeopleLine,
  faPeopleRoof,
  faPercent,
  faPhoneFlip,
  faPhone,
  faPodcast,
  faQuestionCircle,
  faQuoteLeft,
  faQuoteRight,
  faReceipt,
  faRedo,
  faRefresh,
  faRss,
  faSchoolFlag,
  faSchool,
  faScroll,
  faSearch,
  faShareNodes,
  faShare,
  faShieldAlt,
  faSignInAlt,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSpinnerThird,
  faSpinner,
  faStar,
  faTachometerAlt,
  faTag,
  faThLarge,
  faTimesCircle,
  faUpDown,
  faUserCheck,
  faUserCircle,
  faUserCog,
  faUserEdit,
  faUserFriends,
  faUserGraduate,
  faUserGroup,
  faUserLock,
  faUserPlus,
  faUserSlash,
  faUserTie,
  faUser,
  faUsersGear,
  faUsersViewfinder,
  faUsers,
  faVideo,
  faXmark
]

export const brandIcons = [
  faAmazon,
  faApple,
  faDeezer,
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faSoundcloud,
  faSpotify,
  faXTwitter,
  faYoutube
]

export const lightIcons = [
  falAddressCard,
  falBookOpenReader,
  falBooks,
  falCalendar,
  falCalendarUsers,
  falChartSimple,
  falCircleChevronUp,
  falEnvelope,
  falGavel,
  falGlobe,
  falGlobeStand,
  falHandshake,
  falIdCard,
  falList,
  falLocationDot,
  falNewspaper,
  falPartyHorn,
  falPeopleLine,
  falPeopleRoof,
  falPercent,
  falPhone,
  falPodcast,
  falQuoteRight,
  falScaleBalanced,
  falSchoolFlag,
  falSpinnerThird,
  falStar,
  falUserGraduate,
  falUserGroup,
  falUserPlus,
  falUsers,
  falUsersViewfinder,
  falXmark
]
